module.exports = __webpack_public_path__ + "09bb775c26d80c13a450c2143b0c373f.png";